import React, {useContext} from 'react';
import {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Context} from '../../Helpers/Auth';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import imageDark from '../../assets/images/ImageDark.png';
import imagelight from '../../assets/images/ImageLight.png';
import Empty from '../../assets/images/EmptyCart.png';
import SelectComponent from '../Selects/SelectComponent';
import {getMoedas, getProspects} from '../../pages/requests';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {postCarrinho} from './api';

function Carrinho() {
    const {t} = useTranslation();
    const {setCarrinhoItems, carrinhoItems, theme} = useContext(Context);

    const [quantidades, setQuantidades] = useState([]);
    const [moedas, setMoedas] = useState([]);
    const [prospects, setProspects] = useState([]);
    const [moeda, setMoeda] = useState(null);
    const [precoTotal, setPrecoTotal] = useState(0);
    const [prospectEscolhido, setProspectEscolhido] = useState(null);
    const calcularPrecoTotal = () => {
        const total = carrinhoItems.reduce((acc, item) => acc + item.preco * item.quantidade, 0);
        setPrecoTotal(total);
    };

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    } else if (idiomaAtual == 'es') {
        lang = 'ES';
    }

    useEffect(() => {
        getMoedas(lang).then(res => {
            setMoedas(res.data.moedas);
        });
    }, []);
    function getProspectClientes(pesquisa) {
        if (pesquisa.length >= 3) {
            setProspects([]);

            getProspects(0, 9999, lang, pesquisa).then(response => {
                setProspects(
                    response.data.clientes.map(c => {
                        return {
                            ...c,
                            value: c.codigoCliente,
                            label: c.nomeCliente,
                        };
                    }),
                );
            });
        }
    }
    function EnviarCarrinho() {
        if (carrinhoItems.length === 0) {
            toast.warn(t('carrinhoVazio'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            return;
        } else {
            const artigos = carrinhoItems.map(item => ({
                id: item.id,
                quantidade: item.quantidade,
                preco: item.preco,
                unidade: item?.unidade,
            }));
            const body = {
                artigos,
                moeda: moeda.value,
                cliente: prospectEscolhido.value,
            };

            console.log('BODYYYY', body);

            postCarrinho(body).then(response => {
                if (response.data.numEncomenda) {
                    toast.success(t('encCriada') + response.data.numEncomenda, {
                        position: 'top-right',
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'light',
                    });
                    setCarrinhoItems([]);
                } else {
                    toast.error(response.data.error_messages[0], {
                        position: 'top-right',
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'light',
                    });
                }
            });
        }
    }
    useEffect(() => {
        calcularPrecoTotal();
        setQuantidades(carrinhoItems?.map(item => item.quantidade || 1));
    }, [carrinhoItems]);

    const atualizarQuantidade = (index, novaQuantidade) => {
        const novoCarrinho = [...carrinhoItems];
        novoCarrinho[index].quantidade = novaQuantidade;
        setCarrinhoItems(novoCarrinho);
        setQuantidades(prevQuantidades => {
            const novasQuantidades = [...prevQuantidades];
            novasQuantidades[index] = novaQuantidade;
            return novasQuantidades;
        });
    };

    const removerItem = index => {
        const novoCarrinho = [...carrinhoItems];
        novoCarrinho.splice(index, 1);
        setCarrinhoItems(novoCarrinho);
        setQuantidades(prevQuantidades => {
            const novasQuantidades = [...prevQuantidades];
            novasQuantidades.splice(index, 1);
            return novasQuantidades;
        });
    };

    return (
        <section className=" relative z-10 after:contents-[''] after:absolute after:z-0 after:h-full xl:after:w-1/3 after:top-0 after:right-0  after:bg-gray-50  dark:after:bg-gray-600">
            <div className="w-full  px-4 md:px-5 lg-6 mx-auto relative z-10">
                <div className="grid grid-cols-12 ">
                    <div className="col-span-12 xl:col-span-8 lg:pr-8 pt-2 pb-8 lg:py-12 w-full max-xl:max-w-3xl max-xl:mx-auto dark:bg-gray-700 ">
                        <div className="flex items-center justify-between pb-8 border-b border-gray-300 dark:border-gray-800">
                            <h2 className="font-manrope font-bold text-3xl leading-10 text-black dark:text-white"> {t('carrinhoCompras')}</h2>
                            <h2 className="font-manrope font-bold text-xl leading-8 text-gray-600 dark:text-gray-400">{carrinhoItems?.length} Itens</h2>
                        </div>
                        <div className="grid grid-cols-12 mt-8 max-md:hidden pb-6 border-b border-gray-200 dark:border-gray-800">
                            <div className="col-span-12 md:col-span-7">
                                <p className="font-normal text-lg leading-8 text-gray-400">{t('detalheProduto')}</p>
                            </div>
                            <div className="col-span-12 md:col-span-5">
                                <div className="grid grid-cols-5">
                                    <div className="col-span-3">
                                        <p className="font-normal text-lg leading-8 text-gray-400 text-center">{t('quantidade')}</p>
                                    </div>
                                    <div className="col-span-2">
                                        <p className="font-normal text-lg leading-8 text-gray-400 text-center">{t('total')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {carrinhoItems?.map((item, index) => (
                            <div className="flex flex-col min-[500px]:flex-row min-[500px]:items-center gap-5 py-6  border-b border-gray-200 dark:border-gray-800 group">
                                <div className="flex flex-row justify-end">
                                    {' '}
                                    <button onClick={() => removerItem(index)} className="text-red-600 dark:text-red-700">
                                        <DeleteRoundedIcon />
                                    </button>
                                </div>

                                {item.foto ? (
                                    <div className="w-full md:max-w-[126px] ">
                                        <img className="p-4 rounded-t-lg " src={'data:image/jpeg;base64,' + item.foto} alt="product image" />{' '}
                                    </div>
                                ) : (
                                    <div className="w-full md:max-w-[126px] flex flex-row justify-center ">
                                        <img src={theme == 'dark' ? imagelight : imageDark} className="h-20 w-20" />
                                    </div>
                                )}

                                <div className="grid grid-cols-1 md:grid-cols-4 w-full ">
                                    <div className="md:col-span-2">
                                        <div className="flex flex-col max-[500px]:items-center gap-3">
                                            <h6 className="font-semibold text-base leading-7 text-black dark:text-white">
                                                {' '}
                                                {item.id} - {item.nome}
                                            </h6>
                                            <h6 className="font-normal text-base leading-7 text-gray-500 dark:text-gray-400">{item.unidade}</h6>
                                            <h6 className="font-medium text-base leading-7 text-gray-600 dark:text-gray-300 transition-all duration-300 dark:group-hover:text-blue-600 group-hover:text-indigo-600">
                                                {item.preco}
                                                {item.moeda}
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="flex items-center max-[500px]:justify-center h-full max-md:mt-3 ">
                                        <div className="flex items-center h-full">
                                            <button
                                                onClick={() => {
                                                    const novaQuantidade = quantidades[index] - 1;
                                                    if (novaQuantidade >= 1) {
                                                        atualizarQuantidade(index, novaQuantidade);
                                                    }
                                                }}
                                                className="group rounded-l-xl px-5 py-[18px] border border-gray-200    flex items-center justify-center shadow-sm shadow-transparent transition-all duration-500 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-800 dark:hover:bg-gray-900 hover:border-gray-300 hover:shadow-gray-300 dark:hover:shadow-gray-600 focus-within:outline-gray-300">
                                                <svg
                                                    className="stroke-gray-900 transition-all dark:stroke-gray-100 dark:group-hover:stroke-gray-200 duration-500 group-hover:stroke-black"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="22"
                                                    height="22"
                                                    viewBox="0 0 22 22"
                                                    fill="none">
                                                    <path d="M16.5 11H5.5" stroke="" stroke-width="1.6" stroke-linecap="round" />
                                                    <path d="M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                    <path d="M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                </svg>
                                            </button>
                                            <input
                                                type="text"
                                                className="border-y border-gray-200 dark:bg-gray-600 dark:border-gray-600 outline-none text-gray-900 dark:text-white font-semibold text-lg w-full max-w-[73px] min-w-[60px] placeholder:text-gray-900 py-[15px]  text-center bg-transparent"
                                                // placeholder="1"
                                                value={quantidades[index]}
                                                readOnly
                                            />
                                            <button
                                                onClick={() => {
                                                    const novaQuantidade = quantidades[index] + 1;
                                                    atualizarQuantidade(index, novaQuantidade);
                                                }}
                                                className="group rounded-r-xl px-5 py-[18px] border  dark:bg-gray-800 border-gray-200 dark:border-gray-800 dark:hover:bg-gray-900 flex items-center justify-center shadow-sm shadow-transparent transition-all duration-500 hover:bg-gray-50 hover:border-gray-300 hover:shadow-gray-300 dark:hover:shadow-gray-600 focus-within:outline-gray-300">
                                                <svg
                                                    className="stroke-gray-900 transition-all dark:stroke-gray-100 duration-500 dark:group-hover:stroke-gray-200 group-hover:stroke-black"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="22"
                                                    height="22"
                                                    viewBox="0 0 22 22"
                                                    fill="none">
                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-width="1.6" stroke-linecap="round" />
                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="flex items-center max-[500px]:justify-center md:justify-end max-md:mt-3 h-full">
                                        <p className="font-bold text-lg leading-8 text-gray-600 text-center transition-all duration-300 dark:text-gray-300 dark:group-hover:text-blue-600 group-hover:text-indigo-600">
                                            {item.preco}
                                            {item.moeda}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {carrinhoItems?.length == 0 && (
                            <div className="flex flex-row justify-center mt-3 ">
                                <div className="flex flex-col items-center">
                                    <div className="w-full md:max-w-[250px] ">
                                        <img className="p-4 rounded-t-lg " src={Empty} alt="product image" />{' '}
                                    </div>
                                    <span className="text-lg font-semibold text-gray-600">Carrinho vazio</span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className=" col-span-12 xl:col-span-4 bg-gray-50 dark:bg-gray-600 w-full max-xl:px-6 max-w-3xl xl:max-w-lg mx-auto lg:pl-8 py-12">
                        <h2 className="font-manrope font-bold text-3xl leading-10 text-black pb-8 border-b border-gray-300 dark:border-gray-400 dark:text-gray-50"> {t('resumoPedido')}</h2>
                        <div className="mt-8">
                            <div className="flex items-center justify-between pb-6">
                                <p className="font-normal text-lg leading-8 text-black dark:text-white">{carrinhoItems?.length} Itens</p>
                                <p className="font-medium text-lg leading-8 text-black dark:text-white">{precoTotal.toFixed(2)}</p>
                            </div>
                            <form>
                                <div className="flex flex-col mb-4">
                                    <label className="flex  items-center mb-1.5 text-gray-600 text-sm font-medium">Cliente</label>

                                    <SelectComponent
                                        // isDisabled={!editarProposta}
                                        options={prospects}
                                        placeholder={t('pesquisa')}
                                        value={prospectEscolhido}
                                        onChange={e => {
                                            setProspectEscolhido(e);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        onInputChange={e => getProspectClientes(e)}
                                    />
                                </div>{' '}
                                <div className="flex flex-col mb-4">
                                    <label className="flex items-center mb-1.5 text-gray-600 text-sm font-medium">Moeda</label>

                                    <SelectComponent
                                        options={moedas}
                                        value={moeda}
                                        onChange={e => {
                                            setMoeda(e);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('moeda')}
                                    />
                                </div>
                                <div className="flex items-center border-b border-gray-200 dark:border-gray-400"></div>
                                <div className="flex items-center justify-between py-8">
                                    <p className="font-medium text-xl leading-8 text-black dark:text-white">{t('totalPagar')}</p>
                                    <p className="font-semibold text-xl leading-8 text-indigo-600 dark:text-blue-400">{precoTotal.toFixed(2)}</p>
                                </div>
                                <div
                                    onClick={() => EnviarCarrinho()}
                                    className="w-full text-center bg-blue-600 rounded-xl py-3 px-6 font-semibold text-lg text-white transition-all duration-500 hover:bg-blue-700">
                                    {t('finalizarCompra')}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Carrinho;
